import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter } from 'react-router';
import { App } from './App';
import { DogPage } from './common/errors';
import { ProductDetailsPage } from './pages/productDetailsPage';
import { PaymentSelectionPage } from './pages/paymentSelectionPage';
import { ThankYouPage } from './pages/thankYouPage';
import { PreviewOrderPage } from './pages/previewOrderPage';
import { CreatorStorefrontPage } from './pages/storefrontPage/creatorStorefrontPage/CreatorStorefrontPage';
import { LinkCampaignPage } from './pages/linkCampaignPage/LinkCampaignPage';
import { StorefrontPage } from './pages/storefrontPage';
/**
 * Created a browser router that react-router uses to render the current application screen
 * based on the URL.
 *
 * TODO:
 *   - Look into lazy loading: https://reactrouter.com/start/data/route-object#lazy
 */
export const router = createBrowserRouter([
    {
        // Layout routes don't need a "path"
        Component: App,
        // If something throws an error, then the app will display the dog page
        errorElement: _jsx(DogPage, {}),
        children: [
            // Layout routes need a default Outlet
            { index: true, Component: DogPage },
            {
                path: 'checkout',
                children: [
                    { path: 'preview', Component: PreviewOrderPage },
                    { path: 'payment-selection', Component: PaymentSelectionPage },
                    { path: 'confirm', Component: ThankYouPage },
                    { path: 'payment-failed', Component: DogPage },
                ],
            },
            // We need to keep the V1 paths for pages which are direct entry points from SMAs. These are hardcoded on the SMA's ad configuration
            // and use with organic campaigns. To change to a new path, we'd have to work with marketing and the SMAs to update the path across all ads.
            { path: 'painter/products/details/:asin', Component: ProductDetailsPage },
            { path: 'painter/products/linkcampaign', Component: LinkCampaignPage },
            { path: 'painter/content/:aci', Component: CreatorStorefrontPage },
            { path: 'painter/products/store/:id', Component: StorefrontPage },
            // Default fallback if invalid route
            { path: '*', Component: DogPage },
        ],
    },
]);
